import { Component, Input, OnInit, AfterViewInit, Inject, PLATFORM_ID, ElementRef, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { AdService } from '../../services/ad.service';

@Component({
  selector: 'app-adsense-block',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="ad-container" *ngIf="shouldShow$ | async">
      <!-- Placeholder when ads are handled by script but component is visible -->
      <ins #adIns class="adsbygoogle"
           style="display:block"
           [attr.data-ad-client]="adClient"
           [attr.data-ad-slot]="adSlot"
           [attr.data-ad-format]="adFormat"
           [attr.data-full-width-responsive]="fullWidthResponsive">
      </ins>
      <div class="ad-placeholder" *ngIf="isDev">
        <p>AdSpace ({{ adSlot }})</p>
      </div>
    </div>
  `})
export class AdSenseBlockComponent implements OnInit, AfterViewInit {
  @Input() adSlot: string = '';
  @Input() adFormat: string = 'auto';
  @Input() fullWidthResponsive: boolean = true;

  @ViewChild('adIns') adIns!: ElementRef;

  adClient = 'ca-pub-3502947872881560'; // Placeholder ID
  isDev = false; // Set to true to see placeholders during development if script is blocked or invalid
  shouldShow$: Observable<boolean>; // Changed to Observable<boolean> for better typing

  constructor(
    private adService: AdService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.shouldShow$ = this.adService.adsEnabled$;
  }

  ngOnInit() {
    // Determine if we are in dev/localhost to show placeholders
    if (isPlatformBrowser(this.platformId) && window.location.hostname === 'localhost') {
      this.isDev = true;
    }
  }

  ngAfterViewInit() {
    // Small timeout to ensure DOM is ready and prevent race conditions
    setTimeout(() => this.pushAd(), 100);
  }

  pushAd() {
    if (isPlatformBrowser(this.platformId)) {
      // Check if element exists
      if (!this.adIns || !this.adIns.nativeElement) return;

      // Check if ad is already loaded or processing
      if (this.adIns.nativeElement.getAttribute('data-ad-status')) {
        return;
      }

      // Check visibility/dimensions
      // AdSense requires the container to be visible and have non-zero width
      const width = this.adIns.nativeElement.offsetWidth;
      const height = this.adIns.nativeElement.offsetHeight;

      if (width === 0 || height === 0) {
        // Element is likely hidden or not layouted yet. Retry shortly.
        console.log('AdSense: Element has 0 dimensions (w=' + width + ', h=' + height + '), retrying...');
        setTimeout(() => this.pushAd(), 500);
        return;
      }

      try {
        (window as any).adsbygoogle = (window as any).adsbygoogle || [];
        (window as any).adsbygoogle.push({});
      } catch (e) {
        console.error('AdSense error:', e);
      }
    }
  }
}
